import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import Button from './Buttons';

// previousStaysLive: Enterprise only — the current assessment's risks stay active until the new one
// completes and only then become read-only history. The other flows keep their wording.
const ReassessModal = ({ isOpen, onClose, onConfirm, isReassessing, isDocumentAssessment, errorMessage, previousStaysLive = false }) => {
  const [step, setStep] = useState(1);
  const [confirmText, setConfirmText] = useState('');

  useEffect(() => {
    if (isOpen) {
      setStep(1);
      setConfirmText('');
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Reassess Assessment" size="md">
      {step === 1 ? (
        <div>
          <p className="text-sm text-content-primary mb-6">
            Reassessing starts a new, current assessment{isDocumentAssessment ? ' and re-analyzes the uploaded document' : ' with your existing answers carried forward for review'}.{' '}
            {previousStaysLive
              ? "The current assessment's risks and remediations stay active and can still be worked until the new assessment completes. Then they are kept as read-only history you can open from History. Nothing is deleted."
              : "The current assessment's risks and remediations are kept as a read-only historical snapshot you can compare against later — nothing is deleted."}{' '}
            Are you sure you want to reassess?
          </p>
          <div className="flex justify-end space-x-3">
            <Button variant="secondary" onClick={onClose}>
              Go Back
            </Button>
            <Button variant="warning" onClick={() => setStep(2)}>
              Yes
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <p className="text-sm text-content-primary mb-4">
            Type <span className="font-semibold">Confirm</span> to start a new assessment{isDocumentAssessment ? ' and re-analyze the document' : ', keeping your existing answers for review'}.{' '}
            {previousStaysLive
              ? "The current assessment's risks stay active until the new assessment completes, then become read-only history."
              : 'The current assessment becomes a read-only historical snapshot.'}
          </p>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="Type 'Confirm' here"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 mb-4"
            autoFocus
          />
          {errorMessage && (
            <p className="text-sm text-red-600 bg-red-50 border border-red-100 rounded px-3 py-2 mb-4">
              {errorMessage}
            </p>
          )}
          <div className="flex justify-end space-x-3">
            <Button variant="secondary" onClick={onClose}>
              Go Back
            </Button>
            <Button
              variant="warning"
              disabled={confirmText !== 'Confirm' || isReassessing}
              onClick={onConfirm}
            >
              {isReassessing ? 'Reassessing...' : 'Reassess'}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ReassessModal;
